import { PageAccesses } from '../../../guards/page-accesses.model';

export const redirectPoliciesViewer: PageAccesses = {
  menuItem: {
    launcher: false,
    contentGroups: false,
    menuEditor: false,
    applicationListAndMetadata: false,
    brandSettings: false,
    channelList: false,
    configEditor: false,
    redirectPolicies: true,
  },
  screen: {
    launcherScreen: {
      searchPages: false,
      createNewPage: false,
      edit: false,
    },
    pageDetailScreen: {
      viewPageDetails: false,
      edit: false,
      selectorBetweenPageVersions: false,
      countryFilter: false,
      segmentFilter: false,
      openTray: false,
      addTray: false,
      editTray: false,
      deleteTray: false,
      hideTray: false,
      reorderTray: false,
      unpublishThePage: false,
      backToDraft: false,
      createDraft: false,
      deleteDraft: false,
      publishPage: false,
      finishEditing: false,
    },
    trayDetailScreen: {
      backToTrays: false,
    },
    trayEditorScreen: {
      deleteTray: false,
      cancel: false,
      saveToDraft: false,
      trayFunctions: false,
    },
    trayCreationScreen: {
      cancel: false,
      createAsDraft: false,
      trayFunctions: false,
    },
    contentGroupScreen: {
      searchContentGroup: false,
      createNewContentGroup: false,
      filterInReferringPages: false,
      edit: false,
      editDesignated: false,
    },
    contentGroupEditorScreen: {
      editContentGroup: false,
      cancel: false,
      saveAndPublish: false,
      copyFeedUrl: false,
      deleteGroup: false,
      contentGroupFilters: false,
    },
    menuEditorScreen: {
      selectorBetweenProfileType: false,
      uploadOrAddIcons: false,
      hide: false,
      addMenu: false,
      reorderMenuItems: false,
      cancel: false,
      publish: false,
    },
    applicationListAndMetadataScreen: {
      appSelector: false,
      addNewApp: false,
      removeApp: false,
      editName: false,
      editBundleId: false,
      uploadImage: false,
      done: false,
    },
    brandSettingsScreen: {
      showExistingBrandConfig: false,
      uploadImage: false,
      deleteImage: false,
      done: false,
    },
    channelListScreen: {
      syncButton: false,
      channelSelector: false,
      addNewChannel: false,
      removeChannel: false,
      editChannelName: false,
      editChannelId: false,
      editChannelNumber: false,
      done: false,
    },
    configEditorScreen: {
      search: false,
      addConfig: false,
      edit: false,
    },
    configItemEditorScreen: {
      delete: false,
      update: false,
      cancel: false,
      editValue: false,
    },
    configItemCreationScreen: {
      create: false,
      cancel: false,
      configFunctions: false,
    },
    redirectPolicyEditorScreen: {
      search: true,
      add: false,
      edit: false,
      delete: false,
    },
  },
  tenantIndependentMenuItem: {
    generalStbConfigEditor: false,
    generalStreamingConfigEditor: false,
  },
  tenantIndependentScreen: {
    selectTenantScreen: {
      isGeneralSettingsNavigateLinkAvailable: false,
      isOnDemandContentGroupsNavigateLinkAvailable: false,
    },
    generalStbConfigEditorScreen: {
      search: false,
      addConfig: false,
      edit: false,
    },
    generalStbConfigItemEditorScreen: {
      delete: false,
      update: false,
      cancel: false,
      editValue: false,
    },
    generalStbConfigItemCreationScreen: {
      create: false,
      cancel: false,
      configFunctions: false,
    },
    generalStreamingConfigEditorScreen: {
      search: false,
      addConfig: false,
      edit: false,
    },
    generalStreamingConfigItemEditorScreen: {
      delete: false,
      update: false,
      cancel: false,
      editValue: false,
    },
    generalStreamingConfigItemCreationScreen: {
      create: false,
      cancel: false,
      configFunctions: false,
    },
    generalContentGroupScreen: {
      searchContentGroup: false,
      createNewContentGroup: false,
      filterInReferringPages: false,
      edit: false,
    },
    generalContentGroupEditorScreen: {
      editContentGroup: false,
      cancel: false,
      saveAndPublish: false,
      copyFeedUrl: false,
      deleteGroup: false,
      contentGroupFilters: false,
    },
  },
};
